import { timeSlotsTypes } from "../constantes/actionTypes"

const initialState = []

export const timeSlots = (state = initialState, action) => {
    switch (action.type) {
        case timeSlotsTypes.GET_ALL_TIMESLOTS_SUCCESS:
            return action.payload
        case timeSlotsTypes.GET_ALL_TIMESLOTS_FAILURE:
            return initialState
        default:
            return state
    }
}